<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :contextMenuItems='contextMenuItems' :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
              :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :rowDeselected='getChoose' :rowSelecting='rowSelecting'>
      <e-columns :columns='shipColumns' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'>
        <e-column field='taskName' minWidth='10' :headerText='$t("Track.taskName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskId' minWidth='10' :isPrimaryKey='true' :headerText='$t("Track.taskID")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' minWidth='10' :headerText='$t("Track.resourceName")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='typeName' minWidth='10' :headerText='$t("Track.resourceType")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskStatus' minWidth='10' :headerText='$t("Track.taskStatus")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='statusFormat'></e-column>
        <e-column field='createTimeStr' minWidth='10' :headerText='$t("Track.creatTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='startTimeStr' minWidth='10' :headerText='$t("Track.startTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='endTimeStr' minWidth='10' :headerText='$t("Track.endTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='errorStr' minWidth='10' :headerText='$t("Track.result")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <!--<e-column field='errorStr' minWidth='10' :headerText='$t("Track.result")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='resultFormat'></e-column>-->
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getTrackListData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='addDialog' :element='addDialogSetting.element' :styles='addDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AddTrackTask opCode='add' ref="addContent"></AddTrackTask>
      </template>
    </CustomDialog>
    <CustomDialog ref='updateDialog' :element='updateDialogSetting.element' :styles='updateDialogSetting.styles'>
      <template v-slot:dialog-content>
        <UpdateTrackTask opCode='update' ref="updateContent"></UpdateTrackTask>
      </template>
    </CustomDialog>
    <CustomDialog ref='detailDialog' :element='detailDialogSetting.element' :styles='detailDialogSetting.styles'>
      <template v-slot:dialog-content>
        <TrackDetail opCode='detail' ref='detailContent'></TrackDetail>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
  import CustomDialog from '../../common/CustomDialog';
  import TrackDetail from './TrackDetail';
  import AddTrackTask from './AddTrackTask';
  import UpdateTrackTask from './UpdateTrackTask';
  import bus from '../bus.js';
  import { EventBus } from '../../../plugins/eventBus';
  import socketInstance from '../../../plugins/stompSock';

  const { mapGetters, mapActions } = createNamespacedHelpers('trackConfig');
  export default {
    name: 'trackTable',
    components: {
      CustomDialog,
      TrackDetail,
      AddTrackTask,
      UpdateTrackTask
    },
    props: ['trackType'],
    data() {
      return {
        selectionOptions: { type: 'Single' },
        contextMenuItems: [
          { text: `${this.$t('Track.activationTask')}` },
          { text: `${this.$t('Track.suspendTask')}` },
          { text: `${this.$t('Track.taskDeletion')}` },
          { text: `${this.$t('Track.taskTracking')}` },
          { text: `${this.$t('Track.taskDetails')}` }
        ],
        trackStatus: { // 配置不同状态对应的值
          issued: 0,
          greate: 1,
          tracing: 2,
          hangup: 3,
          delete: 4,
          finish: 5
        },
        queryConditions: {
          keywords: '' // 任务名称模糊查询关键字
        },
        currentNeInfo: '',
        data: [],
        primaryDatas: [],
        page: {
          pageNo: 1,
          pageSize: 10,
          totalCount: 0,
          pageCount: 10
        },
        currentSelectDataId: '',
        addDialogSetting: {
          styles: {
            width: '860px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'add',
            title: this.$t('Track.createTask'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.cancel') } },
              { click: this.saveAddTask, buttonModel: { content: this.$t('Track.confirm'), isPrimary: true } }
              //去掉保存功能
              // { click: this.saveTask, buttonModel: { content: this.$t('Track.save'), isPrimary: true } }
            ]
          }
        },
        updateDialogSetting: {
          styles: {
            width: '860px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'update',
            title: this.$t('Track.updateTask'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.cancel') } },
              { click: this.saveUpdateTask, buttonModel: { content: this.$t('Track.confirm'), isPrimary: true } }
              //去掉保存功能
              // { click: this.saveTask, buttonModel: { content: this.$t('Track.save'), isPrimary: true } }
            ]
          }
        },
        detailDialogSetting: {
          styles: {
            width: '810px',
            height: '717px',
            model: true,
            visible: false
          },
          element: {
            target: '#app',
            refName: 'detail',
            title: this.$t('Track.signalingDetails'),
            isClose: true,
            buttonGroup: [
              { click: this.dialogHide, buttonModel: { content: this.$t('Track.close'), isPrimary: true } }
            ]
          }
        },
        websocketSetting: [
          { topic: '/topic/#/TrackTaskServer', clientId: 'track', callback: this.websocketCallback }
        ],
        shipColumns: [
          {
            field: 'ShippedDate',
            headerText: 'Shipped Date',
            format: 'yMd',
            textAlign: 'Right',
            width: 150,
            minWidth: 10
          },
          {
            field: 'ShipCountry',
            headerText: 'Ship Country',
            width: 150,
            minWidth: 10
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['currentNe']),
      ...mapGetters(['neVisionList']),
      ...mapGetters(['resourceIdList'])
    },
    provide: {
      grid: [Reorder, Resize, ExcelExport, ContextMenu]
    },
    methods: {
      ...mapActions(['setCurrentNe']),
      statusFormat(grids, data) {
        const { taskStatus } = data;
        switch (taskStatus) {
          case this.trackStatus.issued:
            return `<span style='color:blue;'>${this.$t('Track.issued')}</span>`;
          case this.trackStatus.greate:
            return `<span style='color:blue;'>${this.$t('Track.greate')}</span>`;
          case this.trackStatus.tracing:
            return `<span style='color:green;'>${this.$t('Track.tracing')}</span>`;
          case this.trackStatus.hangup:
            return `<span style='color:red;'>${this.$t('Track.hangup')}</span>`;
          case this.trackStatus.delete:
            return `<span>${this.$t('Track.delete')}</span>`;
          case this.trackStatus.finish:
            return `<span style='color:orange;'>${this.$t('Track.finish')}</span>`;
          default:
            return taskStatus;
        }
      },
      resultFormat(grids, data) {
        if (data.errorCode === 0) {
          return this.$t('Track.success');
        } else if (data.errorCode === 1) {
          return this.$t('Track.autoActivationFailed');
        }
        //去掉保存功能
        // else if (data.errorCode === 2) {
        //   return `<button eventLS='reSure' class='e-control e-btn e-lib e-primary'>${this.$t('Track.reIssued')}</button>`;
        // }
        return this.$t('Track.error');
      },
      rowSelecting(args){
        if (args.target.innerHTML === this.$t('Track.reIssued')) {
          this.currentSelectDataId = args.data.taskId;
          this.reSaveFunc(args.data);
        }
      },
      getChoose(args) {
        if (args.target.innerHTML === this.$t('Track.reIssued') && args.isInteracted === true) {
          if (args.name === 'rowDeselected' && args.data.length > 0) {
            if (args.data[0].taskId === this.currentSelectDataId) {
              this.reSaveFunc(args.data[0]);
            }
          }
        }
      },
      menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
        if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
          menuArgs.cancel = true;
          return;
        }
        const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
        childList.forEach(elem => {
          elem.style.display = 'block';
        });
        switch (this.getCheckedVals().taskStatus) {
          case this.trackStatus.greate: break;
          case this.trackStatus.tracing: // 正在执行时不显示激活选项
            childList[0].style.display = 'none';
            break;
          case this.trackStatus.hangup: // 挂起时不显示挂起选项
            childList[1].style.display = 'none';
            break;
          case this.trackStatus.delete: break;
          case this.trackStatus.finish: break;
          default:
        }
      },
      menuClickFunc(menuArgs) { // 为右键分配事件
        switch (menuArgs.element.innerText) {
          case `${this.$t('Track.activationTask')}`:
            this.activeTrackPage();
            break;
          case `${this.$t('Track.suspendTask')}`:
            this.hangupTrackPage();
            break;
          case `${this.$t('Track.taskDeletion')}`:
            this.deleteTrackPage();
            break;
          case `${this.$t('Track.taskTracking')}`:
            this.missionTrackPage();
            break;
          case `${this.$t('Track.taskDetails')}`:
            this.detailTrackPage();
            break;
          default:
        }
      },
      dialogHide() {
        this.$refs.addDialog.clear();
        this.$refs.addDialog.close();
        this.$refs.updateDialog.clear();
        this.$refs.updateDialog.close();
        this.$refs.detailDialog.clear();
        this.$refs.detailDialog.close();
      },
      websocketInit() {
        socketInstance.init(this.websocketSetting);
      },
      websocketCallback(msg) {
        console.log('TrackTaskServer:>>>>>', msg);
        if (msg) {
          const data = JSON.parse(msg.body);
          const newData = this.data[this.data.findIndex(v => v.taskId === data.taskId)];
          newData.taskStatus = data.taskStatus;
          newData.endTime = data.endTime;
          newData.endTimeStr = data.endTimeStr;
          newData.errorStr = data.errorStr;
          this.$refs.grid.setRowData(data.taskId, newData);
        }
      },
      getCheckedData(selectOnly) {
        // false: 不支持多选   true: 支持多选
        const selectedRecords = this.$refs.grid.getSelectedRecords();
        if (selectedRecords.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.no_checked')}`});
          return false;
        }
        if (selectedRecords.length > 1 && !selectOnly) {
          EventBus.$emit('toast', {type: 'warning', content: `${this.$t('Alarm.too_many_checked')}!`});
          return false;
        }
        return selectedRecords;
      },
      getCheckedVals() {
        const checkedData = this.getCheckedData(true);
        if (checkedData) {
          return checkedData[0];
        }
        return false;
      },
      getTrackListData() {
        // 获取表格数据
        const This = this;
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        const params = {
          traceType: `${this.trackType}`,
          neIdList: This.currentNeInfo ? [This.currentNeInfo.id] : this.resourceIdList,
          taskName: This.queryConditions.keywords ? This.queryConditions.keywords : '',
          pageNo: parseInt(This.page.pageNo, 10),
          pageSize: parseInt(This.page.pageSize, 10)
        };
        if (params.neIdList.length > 0) {
          This.$axios.post('/lte/ems/track/queryTrack', params).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              const result = response.data.resultVal;
              This.page.totalCount = result.totalCount;
              This.data = result.result;
              This.primaryDatas = This.data;
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        } else {
          This.data = [];
          This.primaryDatas = This.data;
        }
      },
      addTrackPage() {
        if (!this.currentNeInfo) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.pleaseSelectNE')});
        } else {
          this.$refs.addDialog.show();
          this.$refs.addContent.loadNeForm(this.currentNeInfo);
        }
      },
      updateTrackPage() {
        // 任务详情
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          if(checkedData.taskStatus !=0 && checkedData.taskStatus !=1 && checkedData.taskStatus !=3){
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.pleaseSelectEffect')});
            return false;
          }
          this.$refs.updateDialog.show();
          this.$refs.updateContent.loadNeForm(checkedData);
        }
      },
      saveAddTask() {
        const data = this.$refs.addContent.getFormData();
        if (data !== false) {
          data.traceType = this.trackType;
          this.dialogHide();
          this.$axios.post('/lte/ems/track/createTask', data).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === '0') {
              EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
              this.getTrackListData();
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        }
      },
      saveUpdateTask() {
        const data = this.$refs.updateContent.getFormData();
        if (data !== false) {
          data.traceType = this.trackType;
          this.dialogHide();
          this.$axios.post('/lte/ems/track/updateTask', data).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === '0') {
              EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
              this.getTrackListData();
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        }
      },
      reSaveFunc(data) {
        this.$axios.post('/lte/ems/track/createTask', JSON.parse(data.paramsJson)).then((response) => {
          if (response && response.status === 200 && response.data.errorCode === '0') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          this.getTrackListData();
        });
      },
      saveTask() {
        const data = this.$refs.addContent.getFormData();
        if (data !== false) {
          data.traceType = this.trackType;
          this.$axios.post('/lte/ems/track/preserveTraceTask', data).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === '0') {
              this.dialogHide();
              EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
              this.getTrackListData();
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        }
      },
      activeTrackPage() {
        // 激活任务
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          if (checkedData.taskStatus === this.trackStatus.tracing) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.taskInProgress')});
          } else {
            this.$axios.post(`/lte/ems/track/activeTask/${checkedData.taskId}`).then((response) => {
              if (response && response.status === 200 && response.data.errorCode === '0') {
                EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
                this.getTrackListData();
              } else {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            });
          }
        }
      },
      hangupTrackPage() {
        // 挂起任务
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          if (checkedData.taskStatus === this.trackStatus.hangup) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.taskIsPending')});
          } else {
            this.$axios.post(`/lte/ems/track/pauseTask/${checkedData.taskId}`).then((response) => {
              if (response && response.status === 200 && response.data.errorCode === '0') {
                EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
                this.getTrackListData();
              } else {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            });
          }
        }
      },
      finishTrackPage() {
        // 完成任务
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          if (checkedData.taskStatus === this.trackStatus.finish) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.missionAlreadyCompleted')});
          } else {
            this.$axios.post(`/lte/ems/track/finishTask/${checkedData.taskId}`).then((response) => {
              if (response && response.status === 200 && response.data.errorCode === '0') {
                EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
                this.getTrackListData();
              } else {
                EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
              }
            });
          }
        }
      },
      deleteTrackPage() {
        // 删除任务
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          this.$layer.confirm({
            msg: this.$t('Track.deleteTaskInfo'),
            btn1: { msg: this.$t('Track.cancel') },
            btn2: {
              msg: this.$t('Track.confirm'),
              func: () => {
                this.$axios.post(`/lte/ems/track/deleteTask/${checkedData.taskId}`).then((response) => {
                  if (response && response.status === 200 && response.data.errorCode === '0') {
                    EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
                    this.getTrackListData();
                  } else {
                    EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
                  }
                });
              }
            }
          });
        }
      },
      detailTrackPage() {
        // 任务详情
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          const checkedData = checkedDataList[0];
          this.$refs.detailDialog.show();
          this.$refs.detailContent.setTrackId(checkedData);
        }
      },
      missionTrackPage() {
        // 任务跟踪
        const checkedDataList = this.getCheckedData(false);
        if (checkedDataList) {
          if (checkedDataList[0].taskStatus === this.trackStatus.hangup) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.taskIsPending')});
          } else if (checkedDataList[0].taskStatus === this.trackStatus.finish) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.missionAlreadyCompleted')});
          } else {
            // checkedDataList[0].neName = this.neVisionList[checkedDataList[0].neId] ? this.neVisionList[checkedDataList[0].neId][2] : '';
            checkedDataList[0].oamTypeCode = this.neVisionList[checkedDataList[0].neId] ? this.neVisionList[checkedDataList[0].neId][1] : '';
            checkedDataList[0].directoryName = checkedDataList[0].taskId;
            checkedDataList[0].fileName = null;
            this.$emit('addTab', checkedDataList);
          }
        }
      },
      downloadTrackPage() {
        // 下载文件
        const checkedDataList = this.getCheckedData(true);
        if (checkedDataList) {
          this.$axios.get(`/lte/ems/track/checkTaskDirectory/${checkedDataList[0].taskId}`).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              const result = response.data.resultVal;
              checkedDataList[0].oamTypeCode = this.neVisionList[checkedDataList[0].neId] ? this.neVisionList[checkedDataList[0].neId][1] : '';
              checkedDataList[0].fileType = result;
              this.$emit('downloadTab', checkedDataList);
            } else {
              EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
            }
          });
        }
      }
    },
    mounted() {
      bus.$on('loadTrackTable', (neNode) => {
        this.currentNeInfo = neNode;
        this.queryConditions.keywords = '';
        this.page.pageNo = "1";
        this.$refs.pager.ej2Instances.currentPage = 1;
        this.getTrackListData();
        this.setCurrentNe(neNode);
        bus.$emit('curMoData');
      });
      bus.$on('refreshTrackTable', () => {
        this.getTrackListData();
      });
      this.websocketInit();
      // this.getTrackListData();
      setTimeout(this.websocketCallback, 5000);
    },
    beforeDestroy() {
      bus.$off('loadTrackTable');
      bus.$off('refreshTrackTable');
      socketInstance.stopReceiveTopicMsg(this.websocketSetting[0].clientId, this.websocketSetting[0].topic);
    }
  };
</script>
